<div class="chemical-public-view">
  <!-- Loading -->
  <div *ngIf="loading" class="loading-state">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'General.loading' | translate }}</span>
    </div>
  </div>

  <!-- Error / Invalid Token -->
  <div *ngIf="error && !loading" class="error-state">
    <div class="poster-card">
      <div class="poster-header">
        <img [src]="companyLogo" alt="" class="poster-logo" (error)="companyLogo = '/assets/customers/default/logo.png'">
      </div>
      <div class="poster-body text-center py-5">
        <i class="bi bi-shield-exclamation text-danger" style="font-size: 3rem;"></i>
        <h5 class="mt-3">{{ 'Chemical.shareInvalidToken' | translate }}</h5>
      </div>
    </div>
  </div>

  <!-- Chemical Info — Poster/Landing Page -->
  <div *ngIf="chemical && !loading" class="poster-wrapper">
    <div class="poster-card">
      <!-- Header with logo and title -->
      <div class="poster-header">
        <img [src]="companyLogo" alt="" class="poster-logo" (error)="companyLogo = '/assets/customers/default/logo.png'">
        <div class="poster-title">{{ 'Chemical.sharePublicSubtitle' | translate }}</div>
      </div>

      <!-- Chemical identity -->
      <div class="poster-body">
        <div class="chemical-identity">
          <h2 class="chemical-name">{{ chemical.chemicalName }}</h2>
          <div class="chemical-meta">
            <span *ngIf="chemical.tradeName" class="meta-item">{{ chemical.tradeName }}</span>
            <span *ngIf="chemical.casNumber" class="meta-item">CAS: {{ chemical.casNumber }}</span>
            <span *ngIf="chemical.manufacturer" class="meta-item">{{ chemical.manufacturer }}</span>
          </div>
        </div>

        <!-- Signal Word -->
        <div *ngIf="chemical.signalWord" class="signal-word-banner"
             [ngClass]="chemical.signalWord === 'Danger' ? 'signal-danger' : 'signal-warning'">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ chemical.signalWord }}
        </div>

        <!-- Hazard Classes -->
        <div *ngIf="parseList(chemical.hazardClasses).length > 0" class="info-section">
          <h6 class="section-label">
            <i class="bi bi-radioactive me-1"></i>{{ 'Chemical.hazardClasses' | translate }}
          </h6>
          <div class="d-flex flex-wrap gap-2">
            <span *ngFor="let cls of parseList(chemical.hazardClasses)" class="badge badge-soft-danger badge-lg">{{ cls }}</span>
          </div>
        </div>

        <!-- H-Statements -->
        <div *ngIf="chemical.hStatements" class="info-section">
          <h6 class="section-label">{{ 'Chemical.hStatements' | translate }}</h6>
          <p class="section-text">{{ chemical.hStatements }}</p>
        </div>

        <!-- P-Statements -->
        <div *ngIf="chemical.pStatements" class="info-section">
          <h6 class="section-label">{{ 'Chemical.pStatements' | translate }}</h6>
          <p class="section-text">{{ chemical.pStatements }}</p>
        </div>

        <!-- Required PPE -->
        <div *ngIf="parseList(chemical.requiredPPE).length > 0" class="info-section">
          <h6 class="section-label">
            <i class="bi bi-shield-check me-1"></i>{{ 'Chemical.requiredPPE' | translate }}
          </h6>
          <div class="d-flex flex-wrap gap-2">
            <span *ngFor="let ppe of parseList(chemical.requiredPPE)" class="badge badge-soft-primary badge-lg">{{ ppe }}</span>
          </div>
        </div>

        <!-- First Aid -->
        <div *ngIf="chemical.firstAidMeasures" class="info-section">
          <h6 class="section-label">
            <i class="bi bi-heart-pulse me-1"></i>{{ 'Chemical.firstAidMeasures' | translate }}
          </h6>
          <div class="section-text" [innerHTML]="chemical.firstAidMeasures"></div>
        </div>

        <!-- Fire Extinguisher -->
        <div *ngIf="chemical.fireExtinguisher" class="info-section">
          <h6 class="section-label">
            <i class="bi bi-fire me-1"></i>{{ 'Chemical.fireExtinguisher' | translate }}
          </h6>
          <p class="section-text">{{ chemical.fireExtinguisher }}</p>
        </div>

        <!-- Spill Handling -->
        <div *ngIf="chemical.spillHandling" class="info-section">
          <h6 class="section-label">
            <i class="bi bi-droplet me-1"></i>{{ 'Chemical.spillHandling' | translate }}
          </h6>
          <p class="section-text">{{ chemical.spillHandling }}</p>
        </div>

        <!-- Location -->
        <div *ngIf="chemical.location" class="info-section">
          <h6 class="section-label">
            <i class="bi bi-geo-alt me-1"></i>{{ 'Chemical.location' | translate }}
          </h6>
          <p class="section-text">{{ chemical.location }}</p>
        </div>

        <!-- SDS Download -->
        <div *ngIf="getSdsUrl()" class="sds-download">
          <button class="btn btn-outline-primary btn-lg" (click)="downloadSds()">
            <i class="bi bi-file-earmark-pdf me-2"></i>{{ 'Chemical.sharePublicSdsDownload' | translate }}
          </button>
        </div>
      </div>

      <!-- Footer -->
      <div class="poster-footer">
        <span *ngIf="chemical.updatedDate">
          {{ 'Chemical.sharePublicUpdated' | translate }}: {{ chemical.updatedDate | date:'dd.MM.yyyy' }}
        </span>
        <span class="footer-brand">Konti ePortal — {{ 'Chemical.sharePublicSubtitle' | translate }}</span>
      </div>
    </div>
  </div>
</div>
